import { Card, Form, Input, Button, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

const { Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await login(values);
    } catch (error) {
      message.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, var(--wl-primary-pale) 0%, var(--wl-bg) 50%, var(--wl-primary-pale) 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      {/* Decorative circles */}
      <div style={{
        position: 'fixed', top: -80, right: -80, width: 300, height: 300,
        borderRadius: '50%', background: 'rgba(77,184,71,0.15)', pointerEvents: 'none',
      }} />
      <div style={{
        position: 'fixed', bottom: -60, left: -60, width: 220, height: 220,
        borderRadius: '50%', background: 'rgba(255,255,255,0.08)', pointerEvents: 'none',
      }} />

      <Card
        bordered={false}
        style={{
          width: 440,
          borderRadius: 24,
          boxShadow: '0 24px 80px rgba(0,0,0,0.25)',
          overflow: 'hidden',
          border: 'none',
        }}
        bodyStyle={{ padding: 0 }}
      >
        {/* Header band with logo */}
        <div style={{
          background: 'var(--wl-primary-pale)',
          textAlign: 'center',
        }}>
          <img
            src="/logo/WECIRCLE_LOGO with Leaf.svg"
            alt="WeCircle"
            style={{ maxHeight: 110, maxWidth: 220, objectFit: 'contain' }}
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              document.getElementById('login-fallback-title').style.display = 'block';
            }}
          />
          <div id="login-fallback-title" style={{
            display: 'none',
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: 28,
            color: 'var(--wl-primary)',
            letterSpacing: 1,
          }}>
            🦷 WeCircle
          </div>
          {/* <p style={{
            marginTop: 10,
            color: 'rgba(255,255,255,0.80)',
            fontFamily: "'Roboto', sans-serif",
            fontSize: 13,
            letterSpacing: 0.3,
          }}>
            WeCircle
          </p> */}
        </div>

        {/* Form area */}
        <div style={{ padding: '32px 40px 28px' }}>
          <p style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: 20,
            color: 'var(--wl-primary)',
            marginBottom: 24,
          }}>
            Welcome back
          </p>

          <Form form={form} layout="vertical" onFinish={handleSubmit} size="large">
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input
                prefix={<UserOutlined style={{ color: 'var(--wl-text-muted)' }} />}
                placeholder="Enter your Email"
                style={{ borderRadius: 12 }}
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: 'var(--wl-text-muted)' }} />}
                placeholder="Enter your password"
                style={{ borderRadius: 12 }}
              />
            </Form.Item>

            <div style={{ textAlign: 'right', marginBottom: 16, marginTop: -8 }}>
              <span
                style={{ fontSize: 13, color: 'var(--wl-primary)', cursor: 'pointer', fontWeight: 600 }}
                onClick={() => navigate('/forgot-password')}
              >
                Forgot password?
              </span>
            </div>

            <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                style={{
                  height: 48,
                  borderRadius: 9999,
                  fontSize: 15,
                  fontFamily: "'Fredoka One', sans-serif",
                  letterSpacing: 0.5,
                  background: 'linear-gradient(181deg, var(--wl-primary-light) 0%, var(--wl-primary) 100%)',
                  border: 'none',
                  boxShadow: '0 6px 20px rgba(var(--wl-primary-rgb),0.4)',
                }}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <div style={{ marginBottom: 6 }}>
              <Link to="/privacy-policy" style={{ fontSize: 11, color: 'var(--wl-primary)' }}>Privacy Policy</Link>
              <span style={{ margin: '0 8px', color: 'var(--wl-text-muted)' }}>|</span>
              <Link to="/terms-and-conditions" style={{ fontSize: 11, color: 'var(--wl-primary)' }}>Terms of Use</Link>
            </div>
            <Text style={{ fontSize: 11, color: 'var(--wl-text-muted)' }}>
              &copy; {new Date().getFullYear()} WeCircle
            </Text>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Login;
